import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";

@Component({
  selector: 'app-enrollment-confirmation-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <h2 mat-dialog-title>Are you sure you want to decline this request?</h2>
    <mat-dialog-content class="mat-typography">
      <p>Before you proceed, please review the details of the request carefully. By clicking "Decline," you confirm your
        decision to reject this action. Note that once declined, this decision cannot be undone or reversed.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button class="go-back" mat-button mat-dialog-close>GO BACK</button>
      <button class="decline" mat-button [mat-dialog-close]="true" cdkFocusInitial>DECLINE</button>
    </mat-dialog-actions>
  `,
  styles: `

  `
})
export class DeclineDialogComponent {
}
